import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { paymentApi } from '@/api/endpoints';
import { Alert } from '@/components/common/State';
import { DEV_PAYMENT } from '@/utils/devPayment';

export default function PaymentFailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const code = searchParams.get('code');
  const message = searchParams.get('message');
  // 토스는 실패 리다이렉트에도 주문번호를 orderId 로 실어 준다.
  const orderNo = searchParams.get('orderId');

  const [pending, setPending] = useState(false);
  const [devError, setDevError] = useState<string | null>(null);

  /** 개발 환경 전용: 결제 없이 0원 결제 완료로 넘겨 이후 흐름을 테스트한다. */
  async function devApprove() {
    if (!orderNo) return;
    setPending(true);
    setDevError(null);
    try {
      const stored = sessionStorage.getItem('gency03.pendingOrder');
      const cartItemIds: number[] = stored ? (JSON.parse(stored).cartItemIds ?? []) : [];
      await paymentApi.devApprove({ orderNo, cartItemIds });
      sessionStorage.removeItem('gency03.pendingOrder');
      queryClient.invalidateQueries({ queryKey: ['cart'] });
      queryClient.invalidateQueries({ queryKey: ['orders'] });
      navigate(`/order/payment/success?orderId=${orderNo}&amount=0&dev=1`, { replace: true });
    } catch (e) {
      setDevError(e instanceof Error ? e.message : '개발용 결제 처리에 실패했습니다.');
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="state">
      <div className="state__title">결제가 완료되지 않았습니다</div>
      <Alert tone="error">
        {message ?? '결제가 취소되었거나 실패했습니다.'}
        {code && <div className="muted">오류 코드: {code}</div>}
      </Alert>

      {DEV_PAYMENT && orderNo && (
        <div style={{ margin: '12px 0' }}>
          {devError && <Alert tone="error">{devError}</Alert>}
          <button type="button" className="btn btn--outline btn--sm" disabled={pending} onClick={devApprove}>
            {pending ? '처리 중…' : '개발용: 0원 결제 완료로 처리'}
          </button>
          <p className="muted" style={{ fontSize: 12, marginTop: 6 }}>
            로컬·스테이징에서만 보이는 버튼입니다. 결제 없이 주문을 결제 완료 상태로 만듭니다.
          </p>
        </div>
      )}

      <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
        <Link to="/cart" className="btn btn--primary btn--sm">
          장바구니로
        </Link>
        <Link to="/" className="btn btn--outline btn--sm">
          홈으로
        </Link>
      </div>
    </div>
  );
}
